const modules = import.meta.glob<{ default: string }>('./spindl-*.jpg', { eager: true });

export const spindlImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/spindl-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/spindl-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp3d from './fp-3d.jpg';

export const spindlFloorPlans = [
  { image: fp3d, label: "Půdorys – 3D" },
];
